import { render, staticRenderFns } from "./HandyImportDialog.vue?vue&type=template&id=5e53ecb3&scoped=true&"
import script from "./HandyImportDialog.vue?vue&type=script&lang=ts&"
export * from "./HandyImportDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HandyImportDialog.vue?vue&type=style&index=0&id=5e53ecb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53ecb3",
  null
  
)

export default component.exports